import React from "react";


const ServerResponseTracker: React.FC = () => {
  return (<p>COMPONENTE ELIMINADO</p>);
};

export default ServerResponseTracker;
